import { Col, Text } from 'components';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin: ${(props) => (props.marg ? props.marg : '0')};
`;

const ImageBackground = styled.div`
  background: url(${(props) => props.img});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 330px;
  width: 330px;

  justify-content: space-between;

  @media (max-width: 1024px) {
    height: ${window.innerWidth - 35}px;
    width: ${window.innerWidth - 35}px;
  }
`;

const PartnerBox = ({ item, col, marg, mobileMode }) => {
  const { t } = useTranslation();

  return (
    <Wrapper marg={marg} className="partner-box">
      <ImageBackground
        img={item?.images?.mainMed || require('assets/images/partner-placeholder.jpg')}
      >
        {mobileMode && (
          <Col ht="100%" between>
            <Text
              marg="0 0 0 -6px"
              size="72px"
              lineHt="54px"
              spacing="-4px"
              bold
              stencil
              col={col || '#fff'}
            >
              {t('website.ledByPartners')}
            </Text>
          </Col>
        )}
      </ImageBackground>

      {!mobileMode && (
        <Text size="24px" col={col || '#fff'} marg="12px 0 0">
          {item.name}
        </Text>
      )}
    </Wrapper>
  );
};

export default PartnerBox;
